import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { format } from "date-fns";
import { deriveRequestStatus, isStale } from "./clientDocuments.utils";

const formatDate = (value) => {
  if (!value) return "-";
  try {
    return format(new Date(value), "dd/MM/yyyy");
  } catch {
    return "-";
  }
};

const collectedCount = (items) => (items || []).filter((item) => item.state === "FULFILLED").length;

const DocumentRequestList = ({ requests, selectedRequestId, onSelect }) => (
  <TableContainer className="border border-app-border rounded-lg">
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Title</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Items collected</TableCell>
          <TableCell>Created</TableCell>
          <TableCell align="right" />
        </TableRow>
      </TableHead>
      <TableBody>
        {(requests || []).map((request) => {
          const { label, color } = deriveRequestStatus(request);
          const total = request.items?.length ?? 0;
          const collected = collectedCount(request.items);
          const stale = isStale(request, new Date());
          return (
            <TableRow
              key={request.id}
              hover
              selected={request.id === selectedRequestId}
              onClick={() => onSelect(request)}
              className="cursor-pointer"
            >
              <TableCell>
                <div className="flex items-center gap-2">
                  <span>{request.title || "-"}</span>
                  {request.parentRequestId && (
                    <Chip size="small" variant="outlined" label={request.roundLabel} />
                  )}
                  {request.origin === "PARTNER" && (
                    <Chip
                      size="small"
                      color="info"
                      label={`Referrer requested${
                        request.assigneeName ? ` · ${request.assigneeName}` : ""
                      }`}
                    />
                  )}
                </div>
              </TableCell>
              <TableCell>
                <Chip size="small" label={label} color={color} />
              </TableCell>
              <TableCell>
                {collected} / {total} items collected
              </TableCell>
              <TableCell>{formatDate(request.createdAt)}</TableCell>
              <TableCell align="right">
                {stale && (
                  <Tooltip title="Awaiting the client for over 30 days">
                    <WarningAmberIcon fontSize="small" className="text-amber-500" />
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DocumentRequestList;
